module.exports = __webpack_public_path__ + "img/productIcon3.27e268ac.png";